(function () {
  /**
   * 検索ページタブ
   */

  // TOPページ メインビジュアルスライダー
  const mainVisual = () => {
    let mainvisual = document.querySelector('.js-mainvisual');
    if (!mainvisual) return;
    let matchMedia = window.matchMedia('screen and (max-width: 768px)');
    let param = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    };
    let mySwiper = new Swiper('.js-mainvisual', param);

    const init = () => {
      matchMedia.addEventListener("change", slider);
      slider(matchMedia);
    };

    // Swiperのbreakpointではeffectの切り替えができない。
    // そのため、matchmedia変更でsliderのオプションを切り替え
    const slider = (matchMedia) => {
      if (matchMedia.matches) {
        param.effect = 'fade';
        param.slidesPerView = 1;
      } else {
        param.effect = 'slide';
        param.slidesPerView = 'auto';
      }

      mySwiper.destroy(true, true);
      mySwiper = new Swiper('.js-mainvisual', param);
    };

    init();
  };

  const searchTab = () => {
    let tabs = document.querySelectorAll('.js-search-tab');
    if (tabs.length === 0) return;

    let itemsWrap = document.querySelector('.search-items-wrapper');
    let articlesWrap = document.querySelector('.search-articles-wrapper');

    const init = () => {
      tabs.forEach(_tab => {
        _tab.addEventListener('click', () => {
          clickHandler(_tab);
        });
      });
      changeTab();
    };

    const clickHandler = (_target) => {
      tabs.forEach(_tab => {
        _tab.classList.remove('js-active');
      });
      _target.classList.add('js-active');
      changeTab();
    };

    const changeTab = () => {
      if (document.querySelector('.item-tab').classList.contains('js-active')) {
        itemsWrap.style.display = 'block';
        articlesWrap.style.display = 'none';
      } else {
        itemsWrap.style.display = 'none';
        articlesWrap.style.display = 'block';
      }
    };

    init();
  };


  /**
   * ブログ詳細 商品金額をAPIで設定
   */
  const blogProductsPrice = () => {
    let items = document.querySelectorAll('.blog-article .blog-included-item');
    if (items.length === 0) return;

    const init = () => {
      document.querySelectorAll('.blog-article .blog-included-item').forEach(function ($productRef) {
        // let handle = getProductHandleByProductUrl('https://littlerooms.jp/products/2022-da00001#test?utm_source=blog'); // アンカーリンク
        // let handle = getProductHandleByProductUrl('https://littlerooms.jp/products/2022-da00001?utm_source=blog'); // GETクエリ
        // let handle = getProductHandleByProductUrl('https://littlerooms.jp/products/879427'); // セール商品
        let handle = getProductHandleByProductUrl($productRef.querySelector('a').getAttribute('href'));
        getProductByHandle(handle).then((product) => {
          if (!product) {
            // 商品がないとき
            noProduct($productRef);
          } else {
            // 商品が存在するときは金額の更新
            setPrice($productRef, product);
          }
        });
      });
    };

    const noProduct = ($productRef) => {
      $productRef.classList.add('js-is-soldout')
      let $moreElm = $productRef.querySelector('.post__pickup-more');
      $moreElm.innerText = 'SOLD OUT';
    };

    const setPrice = ($productRef, product) => {
      let $titleElm = $productRef.querySelector('.post__pickup-item-name');
      let $priceElm = $productRef.querySelector('.post__pickup-item-price');
      let title = product.title;
      let price = Math.ceil(product.price) / 100; // 下二桁削除
      $titleElm.innerText = title;

      if (product.compare_at_price) {
        // セール販売
        // 定価
        let compareAt = Math.ceil(product.compare_at_price) / 100; // 下二桁削除
        let $compareAtElm = document.createElement('span');
        $compareAtElm.classList.add('compareAt');
        $compareAtElm.innerText = '¥' + compareAt;
        // 割引金額
        let $salePriceElm = document.createElement('span');
        $salePriceElm.classList.add('sale');
        $salePriceElm.innerText = '¥' + price;

        $priceElm.innerText = '';
        $priceElm.append($compareAtElm);
        $priceElm.append($salePriceElm);
      } else {
        // 通常販売
        $priceElm.innerText = '¥' + price;
      }
    };

    /**
     * @see api document
     * https://shopify.dev/api/ajax/reference/product
     * @see object schema
     * https://shopify.dev/api/liquid/objects/product#product-compare_at_price
     {
        available: true
        compare_at_price: null
        compare_at_price_max: 0
        compare_at_price_min: 0
        compare_at_price_varies: false
        created_at: "2020-11-04T22:01:50+09:00"
        description: "<p id=\"special_product_description_detail\">材質：ニトリル繊維</p><p id=\"special_product_description_detail\">※中芯付き、取り外しはできません。</p><p id=\"special_product_description\">もこもこのポンポンがついた、ニット編みクッション。</p><p id=\"special_product_description\"> </p><p id=\"special_product_description\">ベッドに重ねたり、床で過ごす時間に座ったり。</p><p id=\"special_product_description\">2色を組み合わせて使うのもおすすめです。</p><p id=\"special_product_size\">50cm×50cm</p><p id=\"special_product_attention\">※照明やモニターにより実際のお色とは違って見える場合がございます。ご了承の上ご購入いただきますようお願い申し上げます。</p>"
        featured_image: "//cdn.shopify.com/s/files/1/0086/1493/6636/products/FullSizeRender_44.jpg?v=1637909195"
        handle: "507352"
        id: 4602762920054
        images: ['//cdn.shopify.com/s/files/1/0086/1493/6636/products/FullSizeRender_44.jpg?v=1637909195', '//cdn.shopify.com/s/files/1/0086/1493/6636/product…ADFF-9E36-4C6B-A5AD-F26611ABB959.jpg?v=1637909197', '//cdn.shopify.com/s/files/1/0086/1493/6636/products/IMG_2513_1.jpg?v=1637909197', '//cdn.shopify.com/s/files/1/0086/1493/6636/products/IMG_4807.jpg?v=1637909197', '//cdn.shopify.com/s/files/1/0086/1493/6636/product…859B-3986-4C37-B0DF-2D7200787699.jpg?v=1637909198', '//cdn.shopify.com/s/files/1/0086/1493/6636/products/IMG_2526.jpg?v=1637909199', '//cdn.shopify.com/s/files/1/0086/1493/6636/product…17D2-2E9D-40FB-807E-8C15D676725B.jpg?v=1637909199', '//cdn.shopify.com/s/files/1/0086/1493/6636/products/IMG_4106.jpg?v=1637909200', '//cdn.shopify.com/s/files/1/0086/1493/6636/products/IMG_4755_1.jpg?v=1637909201', '//cdn.shopify.com/s/files/1/0086/1493/6636/products/IMG_2525.jpg?v=1637909201']
        options: [ { "name": "Size", "position": 1 } ],
        price: 352000
        price_max: 352000
        price_min: 352000
        price_varies: false
        published_at: "2021-01-04T18:19:58+09:00"
        requires_selling_plan: false
        selling_plan_groups: []
        tags: (5) ['クッション', 'シンプル', 'ファブリック', '有在庫', '通常配送']
        title: "ポンポンサークルクッション"
        type: "クッション"
        url: "/products/507352"
        variants: [
          {
            "id": 794864229, "title": "Small", "options": [ "Small" ], "option1": "Small", "option2": null, "option3": null, "price": 12900,
            "weight": 0, "compare_at_price": null, "inventory_management": "shopify", "available": true, "sku": null, "requires_shipping": true, "taxable": true, "barcode": "49738645"
          },
        ],
        vendor: "Little Rooms select"
    }
    * @param handle {string}
    * @returns {Promise<Product>}
    */
    const getProductByHandle = (handle) => {
      handle = handle.replace(/\?.*$/, "").replace(/\#.*$/, ""); // クエリパラメータ削除・ハッシュタグ削除
      return new Promise((resolve, reject) => {
        fetch("/products/" + handle + ".js")
          .then((response) => {
            if (!response.ok) {
              return null;
            } else {
              return response.json();
            }
          })
          .then((product) => {
            resolve(product);
          });
      });
    }

    const getProductHandleByProductUrl = (url) => {
      return url.split("/").pop();
    };

    init();
  };

  document.addEventListener('page:loaded', function() {
    mainVisual();
    searchTab();
    blogProductsPrice();
  });
})();


/**
 * them.jsから呼ばれるfunctions
 */
function formatDeliveryDate(days) {
  if (days > 5) {
    return Math.ceil(days / 7) + '週間程度';
  } else {
    return days + '営業日以内';
  }
}

// https://shopify.dev/api/ajax/reference/cart#private-properties-and-attributes
// https://www.beehexa.com/devdocs/how-to-add-a-shipping-rate-calculator-to-shopify/
function calcShippingRate() {
  return new Promise(function(resolve, reject) {
    fetch("/cart/prepare_shipping_rates?shipping_address%5Bzip%5D=1500011&shipping_address%5Bcountry%5D=Japan&shipping_address%5Bprovince%5D=Tokyo", {method: 'POST' })
      .then(function(response) { return response.json(); })
      .then(function(preparedData) {
        if (preparedData && preparedData.error && preparedData.error.length > 0) {
          console.error(preparedData.error);
          resolve(null); // エラー時はnullで解決し、theme.jsで「送料は決済ページで計算されます」を表示
          return;
        }

        var count = 0;
        var maxCount = 10;
        var asyncShippingRate = function () {
          fetch('/cart/async_shipping_rates.json')
            .then(function(response) { return response.json(); })
            .then(function(data) {
              if (data && data.shipping_rates) {
                resolve(data.shipping_rates);
              } else {
                if (count++ > maxCount) {
                  resolve(null); // リトライ上限時もnullで解決
                  return;
                }
                setTimeout(asyncShippingRate, 1000);
              }
            });
        };
        asyncShippingRate();
      })
      .catch(function(err) {
        console.error('calcShippingRate fetch error:', err);
        resolve(null); // ネットワークエラー時もnullで解決し、theme.jsで「送料は決済ページで計算されます」を表示
      });
  });
}

(new Promise(function(resolve, reject) {
  var handle = setInterval(function() {
    if (window.__pagefly_helper_store__) {
      resolve();
      clearInterval(handle);
    }
  }, 500);
})).then(function() {
  console.log('pagefly_helper init');
  window.__pagefly_helper_store__.subscribe(function() {
    document.dispatchEvent(new Event('cart:build'));
  });
});


function switchCategorizedCollection(navSelector, collectionSelector, className, targetIndex) {
  [navSelector, collectionSelector].forEach(function(selector) {
    var targets = document.querySelectorAll(selector);
    targets.forEach(function(target, idx) {
      if (idx === targetIndex) {
        target.classList.add(className);
      } else {
        target.classList.remove(className);
      }
    });
  });
}


// 商品追加後にドロップダウンカートを開く
(function() {
  if (window.__lrCartDropdownOpenHookInstalled) return;
  window.__lrCartDropdownOpenHookInstalled = true;

  document.addEventListener('ajaxProduct:added', function() {
    if (!window.theme || !theme.settings || theme.settings.cartType !== 'dropdown') return;
    document.dispatchEvent(new CustomEvent('cart:open'));
  });
})();